import React from 'react';
import Image from './Image';
import LensSlider from './LensSlider';
import { useSelector } from 'react-redux';

/**
 * @param props.lensFilename
 * @param props.colorFilename
 */
const ImageSlider = props => {
    const baseURLs = useSelector(state => state.main.baseURLs);
    const opacity = useSelector(state => state.slider);

    return (
        <>
            <div className="slider-image-container">
                <Image
                    imageClass="lens-image slider-image"
                    url={baseURLs.projectImage}
                    fileName={props.lensFilename}
                    alt="Indoor lens slider"
                />
                <Image
                    imageClass="color-image slider-image"
                    url={baseURLs.projectImage}
                    fileName={props.colorFilename}
                    style={opacity}
                    alt="Outdoor lens slider"
                />
            </div>
            <LensSlider />
        </>
    );
};
export default ImageSlider;
